import { LS } from 'ls-ts';
import { useEffect, useState } from 'react';

import { userService } from '#/client';
import { FormInputVariants, StorageKeys } from '#/service/constants';

import { InputField, TInputState } from '../Form';

export function useLoginInputs() {
  const [rememberMe, setRememberMe] = useState<TInputState>({ value: false });
  const [emailField, setEmailField] = useState<InputField>();
  const [display, setDisplay] = useState<InputField[]>();
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    userService
      .getLoginInputs()
      .then((res) => {
        const data = res.data;

        const respDisplay = data.display as InputField[];

        const emailField = respDisplay.find(
          (input) => input.variant === FormInputVariants.EMAIL
        );

        if (emailField) {
          const storedEmail = LS.read<string>(StorageKeys.LOGIN_EMAIL);

          if (storedEmail) {
            emailField.defaultValue = storedEmail;
            setRememberMe({ value: true });
          }
          setEmailField(emailField);
        }

        setDisplay(respDisplay);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  return { loading, error, emailField, display, rememberMe, setRememberMe };
}
